import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { useAuth, useSession } from "~/contexts/auth-context";
import { useErrorToast } from "~/hooks/use-error-toast";
import { TERMS_AND_CONDITIONS_VERSION } from "~/shared/constants";
import { ProfileForm } from "./profile-form";

export function ProfileModal() {
  const { user } = useSession();
  const { updateUserProfile, error } = useAuth();
  const { t } = useTranslation("profile");

  useErrorToast(error);

  const hasAcceptedCurrentTerms =
    user.settings?.acceptedTermsVersion === TERMS_AND_CONDITIONS_VERSION;

  const needsProfile = !user.firstName || !user.lastName;
  const showModal = hasAcceptedCurrentTerms && needsProfile;

  return (
    <Dialog open={showModal}>
      <DialogContent showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>{t("profile:setup.title")}</DialogTitle>
          <DialogDescription hidden>
            {t("profile:setup.description")}
          </DialogDescription>
        </DialogHeader>

        <ProfileForm
          userId={user.id}
          photoUrl={user.photoUrl}
          email={user.email ?? ""}
          firstName={user.firstName}
          lastName={user.lastName}
          updateUserProfile={updateUserProfile}
        />
      </DialogContent>
    </Dialog>
  );
}
